"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _context = require("../../libs/translationsUtils/context");

var DateFormatter = function DateFormatter(props) {
  return (0, _preact.h)(_context.TranslationContext.Consumer, null, function (_ref) {
    var language = _ref.language;
    return new Intl.DateTimeFormat(language, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(new Date(props.date).getTime());
  });
};

var _default = DateFormatter;
exports.default = _default;